import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { ManageMessageTemplateModal } from './ManageMessageTemplateModal.component'

const withUnmountHoc = withUnmountTransition(ManageMessageTemplateModal)
export { withUnmountHoc as ManageMessageTemplateModal }
